import dynamic from 'next/dynamic';
import { ElementType } from 'react';

const LAYOUT_MAPPER: Record<string, ElementType> = {
  classic: dynamic(() => import('./Classic')),
  wide: dynamic(() => import('./Wide')),
};

export default LAYOUT_MAPPER;
